import React from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import logo from "../../Assets/logo.png";
import { addFilterSearchTerm } from "../Features/filter/filter";

const ProjectsNavbar = () => {
    const dispatch = useDispatch();

    const handleSearchTerm = (e) => {
        dispatch(addFilterSearchTerm(e.target.value));
    };

    return (
        <div>
            <div class="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
                <img src={logo} class="h-10 w-10" alt="logo" />
                <input
                    class="flex items-center h-10 px-4 ml-10 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
                    type="search"
                    placeholder="Search for anything…"
                    onChange={handleSearchTerm}
                />
                <div class="ml-10">
                    <NavLink
                        className="mx-2 text-sm font-semibold text-indigo-700 "
                        to="/projects"
                    >
                        Projects
                    </NavLink>
                    <NavLink
                        className="mx-2 text-sm font-semibold text-gray-500 hover:text-indigo-700"
                        to="/teams"
                    >
                        Team
                    </NavLink>
                </div>
                <buton class="flex items-center justify-center w-8 h-8 ml-auto overflow-hidden rounded-full cursor-pointer">
                    <img
                        src="https://assets.codepen.io/5041378/internal/avatars/users/default.png?fit=crop&format=auto&height=512&version=1600304177&width=512"
                        alt=""
                    />
                </buton>
            </div>
        </div>
    );
};

export default ProjectsNavbar;
